export { APP_STORE_URL } from "../../data/site";

export const deepLink = (token) => `sistersafe://invite/${encodeURIComponent(token)}`;

const friend = (name) => name || "your friend";

export const STATUS_CONTENT = {
  pending: (d) => ({
    tone: "ok",
    title: `${d.inviter_name || "Someone"} invited you to join her SisterSafe Circle`,
    body: `SisterSafe helps women stay connected with people they trust during journeys, dates and nights out. Accept ${
      d.inviter_name ? `${d.inviter_name}'s` : "the"
    } invitation in the app to follow her Safe Journeys and receive her alerts.`,
    cta: "Open in SisterSafe to Accept",
  }),
  accepted: () => ({
    tone: "ok",
    title: "This invitation was already accepted",
    body: "Open SisterSafe to see your Circle.",
    cta: "Open SisterSafe",
  }),
  declined: () => ({
    tone: "muted",
    title: "This invitation was declined",
    body: "If that was a mistake, ask your friend to send a new invite link.",
  }),
  expired: (d) => ({
    tone: "muted",
    title: "This invitation has expired",
    body: `Invites are valid for 7 days. Ask ${friend(d.inviter_name)} to send a fresh link.`,
  }),
  invalid: () => ({
    tone: "muted",
    title: "This invitation isn't valid",
    body: "The link may be incomplete or the invite was removed. Ask your friend to send a new one.",
  }),
  error: () => ({
    tone: "muted",
    title: "We couldn't load this invitation",
    body: "Please check your connection and try again.",
    retry: true,
  }),
};

export const contentFor = (status, data) =>
  (STATUS_CONTENT[status] || STATUS_CONTENT.invalid)(data || {});
